import React, { useState, useEffect} from 'react';
import {Button, Container}  from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { ThumbUp, ThumbDown } from '@mui/icons-material';

import * as Config from '../Config.js'; 

import TopAppBar from './TopAppBar' ;
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";


const FriendRequestsScreen = (props) => {    
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    const [requests, setRequests] = useState([]) ;
       
    
    const listFriendRequests = () => {            
        console.log('listFriendRequests') ;
        

        fetch(Config.apiUrl  + '/site/friendrequests',  {
            credentials: 'include',
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
                console.log('gotFriends and requests') ;
                setRequests(res.requests) ;
            } else {
                navigate('/') ;
            }
        })
    }
    

    useEffect(() => { 
        console.log('useeffect invoked') ;
        listFriendRequests() ;
    // the next line prevents the useEffect excessive warning
    // eslint-disable-next-line react-hooks/exhaustive-deps    
    },[]) 
    
    

   
    const manageFriend = (mode, id_friend) => {
        
        const data = new FormData();
        data.append('mode', mode);
        data.append('id_friend', id_friend);

        fetch(Config.apiUrl  + '/site/managefriend',  {
            method: 'POST',
            credentials: 'include', 
            body: data,
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
                navigate('/my_friends') ;
            } else {
                navigate('/') ;
            }
        })
    }

    
    return(
        <Container maxWidth="sm" >
            <TopAppBar 
                title={t("Friend Requests")} 
                returnLink={"/my_friends"}
            />
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 200 }} aria-label="simple table">     
        
                    <TableBody>
                        {requests.map((usr, i) => 
                          <TableRow
                            key={i}
                          >
                            <TableCell component="th" scope="row" sx={{fontWeight: 'bold'}}>
                              {usr.name + ' ' + t("Requests to become friend")}
                            </TableCell>
                            <TableCell align="right">
                                <Button 
                                    onClick={() => manageFriend('reject', usr.id)}
                                    variant="outlined"
                                    color="error"
                                    startIcon={<ThumbDown color="error"/>}
                                >
                                </Button>
                            </TableCell>
                            <TableCell align="right">
                                <Button 
                                    onClick={() => manageFriend('accept', usr.id)}
                                    variant="outlined"
                                    color = "success"
                                    startIcon={<ThumbUp color="success"/>}
                                >
                                </Button>
                            </TableCell>
                          </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>        
        </Container>
    );
}

export default FriendRequestsScreen;